import { render, staticRenderFns } from "./AddCollection.vue?vue&type=template&id=af627d0a&"
import script from "./AddCollection.vue?vue&type=script&lang=ts&"
export * from "./AddCollection.vue?vue&type=script&lang=ts&"
import style0 from "./AddCollection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports